// extracted by mini-css-extract-plugin
export default {"more":"OHlyt","moreIcon":"Ay9f0","icon":"C63Da","horizontal":"fNitK","container":"Dito6"};